var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductAvatar4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 143,
    viewBox: "0 0 195 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.285645,
    width: 195,
    height: 142,
    rx: 6.85714,
    fill: "#7879F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_497_2477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.267 103.147L70.589 103.539C67.4329 103.553 64.8593 101.009 64.8171 97.8736L64.3933 45.56C64.3757 42.4034 66.9166 39.8322 70.0515 39.7935L124.73 39.4012C127.886 39.3871 130.459 41.9314 130.502 45.0669L130.925 97.3804C130.943 100.537 128.402 103.108 125.267 103.147Z",
    fill: "url(#paint0_linear_497_2477)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.189 95.3356L74.1221 95.6993C72.7625 95.7114 71.6681 94.6381 71.6545 93.2782L71.2898 50.0436C71.2762 48.6837 72.3481 47.5903 73.7078 47.5783L121.774 47.2145C123.134 47.2024 124.228 48.2757 124.242 49.6356L124.607 92.8703C124.62 94.2301 123.548 95.3235 122.189 95.3356Z",
    fill: "#A5A6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0839 64.8252C91.4703 63.6328 91.6265 61.5411 90.4328 60.1532C89.2391 58.7653 87.1475 58.6067 85.7612 59.7991C84.3748 60.9914 84.2187 63.0831 85.4124 64.4711C86.6061 65.859 88.6976 66.0175 90.0839 64.8252Z",
    fill: "#FACE8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8818 79.1059L81.5368 79.2292L85.8319 74.2999L87.9794 71.8352L90.1269 69.3706L92.3157 71.8044L94.5044 74.2382L98.8818 79.1059Z",
    fill: "#15112D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0685 70.4129L90.6111 70.1506L90.3526 70.3892L89.7468 70.2082L89.2095 70.4261L89.6698 69.8978L89.9 69.6337L90.1302 69.3695L90.3648 69.6304L90.5993 69.8912L91.0685 70.4129Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.487 79.0046L88.2101 79.1843L94.4693 72.0008L97.5989 68.4091L100.728 64.8174L103.918 68.3642L107.108 71.911L113.487 79.0046Z",
    fill: "#C5C5C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.101 66.3363L101.435 65.954L101.058 66.3017L100.175 66.038L99.3919 66.3556L100.063 65.5857L100.398 65.2008L100.734 64.8158L101.075 65.1959L101.417 65.5761L102.101 66.3363Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_497_2477",
    x: 46.6079,
    y: 30.5088,
    width: 102.103,
    height: 99.7086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.89261
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_497_2477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_497_2477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_497_2477",
    x1: 68.0601,
    y1: 37.0983,
    x2: 126.517,
    y2: 105.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAvatar4);
export default __webpack_public_path__ + "static/media/productAvatar4.8302a5c5fde2c714c36708405c2026b0.svg";
export { ForwardRef as ReactComponent };